import React from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function ChangePlayList(props) {

  const title = () => { 
    if (props.isEmpty) {
      return TR.cm_add_playqueue;
    } else {
      return TR.cm_replace_or_add_playqueue;
    }
  };

  const replaceButton = () => { 
    if (!props.isEmpty) {
      return <Button onClick={props.onReplace} color="success">{TR.cm_replace}</Button>;
    }
  };

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onAddToEnd();
    }
  };

  return (
    <BDialog openToLeft={props.openToLeft} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{title()}</DialogTitle>
      <DialogContent>

      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          {replaceButton()}
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={props.onAddToEnd}>{TR.cm_add_to_end}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default ChangePlayList;